import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const MemoApis = {
  selectAllMemo: new Api({
    url: "/api/memo/selectAll",
    desc: "查询所有备忘录",
    method: RequestEnum.GET
  })
};

export default MemoApis;

export interface Memo {
  id: number;
  title: string;
  content: string;
  status: number;
  createTime: string;
  updateTime: string;
}
